import React, { useState } from 'react'
import { Header, Page } from 'components'
import {
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core'
import { BackButton } from 'components/BackButton/BackButton'
import { Espelho } from 'components/Espelho'
import { useFormState } from 'hooks/useFormState'
import { useReportService } from 'hooks/useReportService'
import { ExibirArquivo } from 'components/ExibirArquivo'
import useRouter from 'utils/useRouter'
import { InserirArquivo } from 'components/InserirArquivo'

import useStyles from './styles'

const schema = {
  tipoReport: {
    presence: { allowEmpty: false, message: '^Report é obrigatório' },
  },
  descricao: {
    presence: { allowEmpty: false, message: '^Descrição é obrigatório' },
  },
}

export const CadastroReport = (props) => {
  const { route } = props
  const classes = useStyles()
  const reportService = useReportService()
  const router = useRouter()
  const [abrirEspelho, setAbrirEspelho] = useState(false)
  const [processandoReport, setProcessandoReport] = useState(false)
  const [processandoArquivo, setProcessandoArquivo] = useState(false)
  const reportForm = useFormState(schema, {
    tipoReport: null,
    descricao: null,
    arquivos: [],
  })

  const handleOpenEspelho = () => {
    setAbrirEspelho(true)
  }

  const handleConfirmar = async () => {
    await reportService.cadastrarReport(reportForm.formState.values, setProcessandoReport)
    router.history.push('/reportpage')
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          <Grid
            className={classes.fieldGroup}
            alignItems="center"
            spacing={0}
            container
            justifyContent="space-between"
            md={12}
            sm={12}
            xs={12}
          >
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  <Typography className={classes.tituloCampo}>
                    Qual o tipo de feedback deseja registrar?
                  </Typography>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="tipoReport"
                  value={
                    reportForm.formState.values ? reportForm.formState.values.tipoReport : null
                  }
                  onChange={(event, newValue) => {
                    reportForm.handleChangeNewValueByNameProperty(event, newValue, 'tipoReport')
                  }}
                  required
                >
                  <FormControlLabel value="Bug" control={<Radio />} label="Bug e/ou erros" />
                  <FormControlLabel
                    sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: 200,
                      },
                    }}
                    value="Melhoria"
                    control={<Radio />}
                    label="Sugestões de melhorias"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={12} sm={12} xs={12} className={classes.fieldDescricao}>
              <TextField
                label="Descrição Geral"
                minRows={5}
                name="descricao"
                fullWidth
                multiline
                variant="outlined"
                value={reportForm.formState.values ? reportForm.formState.values.descricao : null}
                onChange={reportForm.handleChange}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <InserirArquivo
                rotaUpload="/arquivo/report"
                rotaLoadImagem="/arquivo/report"
                setFormState={reportForm.setFormState}
                formState={reportForm.formState}
                processando={processandoArquivo}
                setprocessandoArquivo={setProcessandoArquivo}
                tipos={['image', 'pdf']}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="space-between">
            <Grid item>
              <BackButton />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={handleOpenEspelho}
                className={classes.botoesFormulario}
                color="secondary"
                // disabled={formularioComErro}
              >
                Cadastrar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Espelho
        aberto={abrirEspelho}
        setAberto={setAbrirEspelho}
        handleConfirmar={handleConfirmar}
        processando={processandoReport}
        titulo="CONFIRMAÇÃO DOS DADOS PREENCHIDOS"
      >
        <Grid item md={12} sm={12} xs={12}>
          <Typography className={classes.tituloCampo}>INFORMAÇÕES GERAIS</Typography>
          <br />
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <Typography>
            <b>Tipo de Ocorrência</b>
          </Typography>
          <Typography>
            {reportForm.formState.values ? reportForm.formState.values.tipoReport : 'Não informado'}
          </Typography>
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <Typography>
            <b>Descrição</b>
          </Typography>
          <Typography>
            {reportForm.formState.values ? reportForm.formState.values.descricao : 'Não informado'}
          </Typography>
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="h6">Arquivo</Typography>
        </Grid>
        {reportForm.formState.values.arquivos?.map((arquivo) => (
          <Grid className={classes.item} item md={2} sm={4} xs={7}>
            <ExibirArquivo id={arquivo} rotaLoadFile="/arquivo/report" />
          </Grid>
        ))}
      </Espelho>
    </Page>
  )
}
